import { Typography } from "@mui/material";

const ReportTitle = () => (
    <Typography
      sx={{
        fontWeight: "bold",
        fontFamily: "sans-serif",
        fontSize: { xs: "16px", md: "19px" },
        color: "#343C6A",
        textAlign: { xs: "center", md: "left" },
      }}
    >
      Fund Transfer Report
    </Typography>
  );
  
  export default ReportTitle;